export default __webpack_public_path__ + "static/media/CNLOGO.d603a965.svg";